//@ts-nocheck
import { Modal, message } from "antd";
import styled from "styled-components";
import { CloseCircleOutlined } from "@ant-design/icons";
import React from "react";

import { deletePayrunFile } from "../../../actions/payrun";

export interface DeletePayrunFileProps {
  getFiles: () => void;
}

const Icon = styled(CloseCircleOutlined)`
  color: #ff4d4f !important;
`;

export const usePayrunDeleteFile = ({ getFiles }: DeletePayrunFileProps) => {
  const handleDeleteFile = ({ payrunId, id, fileName }) => {
    Modal.confirm({
      title: `Confirm to delete file ${fileName}?`,
      content: "You cannot undo this action.",
      icon: <Icon />,
      type: "confirm",
      okText: "Delete",
      cancelText: "Cancel",
      width: 500,
      zIndex: 999,
      onOk: () => {
        deletePayrunFile({ payrunId, id }).then((resp) => {
          if (resp.status) {
            getFiles();
            return message.success("File deleted successfully");
          }
          return message.error(resp.message);
        });
      },
      okType: "danger",
      onCancel: () => {
        return;
      },
    });
  };

  return { handleDeleteFile };
};
